import { render, staticRenderFns } from "./OverviewSection.vue?vue&type=template&id=b10ab09e"
import script from "./OverviewSection.vue?vue&type=script&lang=js"
export * from "./OverviewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports